import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-list" }
const _hoisted_2 = { class: "qrcode-text" }

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import { checkTokenExpired } from '@/utils/request';
import { getAPPUrl, getPDAUrl, getGenerateQrCode } from '@/services/micro-app-cache';


const __default__ = {
  name: 'DownloadApp'
};

interface DownloadItem {
  title: string;
  url: string;
}

// 定义下载URL对象类型
interface DownloadUrls {
  register: string;
  app: string;
  pda: string;
}

// 响应式数据

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();

// 定义下载链接项类型
const downUrl = ref<DownloadUrls>({
  register: '',
  app: '',
  pda: ''
});

// 计算属性：数据列表
const dataList = computed<DownloadItem[]>(() => {
  const items: DownloadItem[] = [
    {
      title: 'Invite users',
      url: downUrl.value.register
    },
    {
      title: 'PDA Download',
      url: downUrl.value.pda
    },
    {
      title: 'DSP PDA Download',
      url: downUrl.value.app
    },
    {
      title: 'Delivery APP',
      url: `${window.location.origin}/h5/appQrcode/index.html`
    }
  ];

  return items.filter(item => item.url);
});

const hasFetchedDownloadUrl = ref(false);

// 获取下载链接
const getDownloadUrl = async () => {
  try {
    const refreshResult = await checkTokenExpired();
    if (refreshResult === false) {
      throw new Error('Token refresh failed.');
    }
    const [appRes, pdaRes, qrRes] = await Promise.allSettled([
      getAPPUrl(),
      getPDAUrl(),
      getGenerateQrCode()
    ]);

    // 处理APP URL
    if (appRes.status === 'fulfilled') {
      downUrl.value.app = appRes.value?.msg || '';
    }

    // 处理PDA URL
    if (pdaRes.status === 'fulfilled') {
      downUrl.value.pda = pdaRes.value?.msg || '';
    }

    // 处理生成二维码URL
    if (qrRes.status === 'fulfilled' && qrRes.value.code === 200) {
      downUrl.value.register = qrRes.value?.data || '';
    }
  } catch (error) {
    console.error('Failed to fetch download URLs:', error);
  } finally {
    hasFetchedDownloadUrl.value = true;
  }
};

// 等 userInfo 就绪后再拉取，用 hasFetchedDownloadUrl 避免重复请求；退出登录时重置以便下次登录会重新拉取
watch(
  () => store.state.user?.userInfo,
  (userInfo) => {
    if (!userInfo) {
      hasFetchedDownloadUrl.value = false;
      return;
    }
    if (!hasFetchedDownloadUrl.value) getDownloadUrl();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: "bottom",
    width: "auto",
    trigger: "hover",
    "popper-class": "download-app-popper"
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('main_header_download_app')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card-item",
            key: item.title
          }, [
            _createVNode(QrcodeVue, {
              value: item.url,
              size: 180,
              level: "H"
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1)
          ]))
        }), 128))
      ])
    ]),
    _: 3
  }))
}
}

})